import {CardItem} from '@domain/last-modified-card-object/card-item';

export class TextileDataLastModified {
  private readonly _machineQuality: CardItem;
  private readonly _yarnType: CardItem;
  private readonly _finishingTemplate: CardItem;
  private readonly _color: CardItem;
  private readonly _coloredYarnSet: CardItem;
  private readonly _weftColoredYarnSet: CardItem;
  private readonly _creel: CardItem;
  private readonly _weaveStructure: CardItem;
  private readonly _colorSet: CardItem;
  private readonly _yarnSet: CardItem;
  private readonly _companyWeaveStructure: CardItem;
  private readonly _coloredYarn: CardItem;
  private readonly _manageWeaveStructure: CardItem;
  private readonly _weaveProduct: CardItem;
  private readonly _groupedWeaveStructure: CardItem;
  private readonly _tuftProduct: CardItem;

  public constructor(
    machineQuality: CardItem,
    yarnType: CardItem,
    finishingTemplate: CardItem,
    color: CardItem,
    creel: CardItem,
    weaveStructure: CardItem,
    coloredYarnSet: CardItem,
    weftColoredYarnSet: CardItem,
    colorSet: CardItem,
    yarnSet: CardItem,
    companyWeaveStructure: CardItem,
    coloredYarn: CardItem,
    manageWeaveStructure: CardItem,
    weaveProduct: CardItem,
    groupedWeaveStructure: CardItem,
    tuftProduct: CardItem
  ) {
    this._machineQuality = machineQuality;
    this._yarnType = yarnType;
    this._finishingTemplate = finishingTemplate;
    this._color = color;
    this._creel = creel;
    this._weaveStructure = weaveStructure;
    this._coloredYarnSet = coloredYarnSet;
    this._weftColoredYarnSet = weftColoredYarnSet;
    this._colorSet = colorSet;
    this._yarnSet = yarnSet;
    this._companyWeaveStructure = companyWeaveStructure;
    this._coloredYarn = coloredYarn;
    this._manageWeaveStructure = manageWeaveStructure;
    this._weaveProduct = weaveProduct;
    this._groupedWeaveStructure = groupedWeaveStructure;
    this._tuftProduct = tuftProduct;
  }

  public get machineQuality(): CardItem {
    return this._machineQuality;
  }

  public get yarnType(): CardItem {
    return this._yarnType;
  }

  public get finishingTemplate(): CardItem {
    return this._finishingTemplate;
  }

  public get color(): CardItem {
    return this._color;
  }

  public get creel(): CardItem {
    return this._creel;
  }

  public get weaveStructure(): CardItem {
    return this._weaveStructure;
  }

  public get coloredYarnSet(): CardItem {
    return this._coloredYarnSet;
  }

  public get weftColoredYarnSet(): CardItem {
    return this._weftColoredYarnSet;
  }

  public get colorSet(): CardItem {
    return this._colorSet;
  }

  public get yarnSet(): CardItem {
    return this._yarnSet;
  }

  public get companyWeaveStructure(): CardItem {
    return this._companyWeaveStructure;
  }

  public get coloredYarn(): CardItem {
    return this._coloredYarn;
  }

  public get manageWeaveStructure(): CardItem {
    return this._manageWeaveStructure;
  }

  public get weaveProduct(): CardItem {
    return this._weaveProduct;
  }

  public get groupedWeaveStructure(): CardItem {
    return this._groupedWeaveStructure;
  }

  public get tuftProduct(): CardItem {
    return this._tuftProduct;
  }

  public static fromJSON(lastModifiedJSON: any): TextileDataLastModified {
    return new TextileDataLastModified(
      CardItem.machineQualityFromJSON(lastModifiedJSON.machineQuality),
      CardItem.yarnTypeFromJSON(lastModifiedJSON.yarnType),
      CardItem.finishingTemplateFromJSON(lastModifiedJSON.finishingTemplate),
      CardItem.colorFromJSON(lastModifiedJSON.color),
      CardItem.creelFromJSON(lastModifiedJSON.creel),
      CardItem.weaveStructureFromJSON(lastModifiedJSON.weaveStructure),
      CardItem.coloredYarnSetFromJSON(lastModifiedJSON.coloredYarnSet),
      CardItem.weftColoredYarnSetFromJSON(lastModifiedJSON.weftColoredYarnSet),
      CardItem.colorSetFromJSON(lastModifiedJSON.colorSet),
      CardItem.yarnSetFromJSON(lastModifiedJSON.yarnSet),
      CardItem.companyWeaveStructureFromJSON(lastModifiedJSON.companyWeaveStructure),
      CardItem.coloredYarnFromJSON(lastModifiedJSON.coloredYarn),
      CardItem.manageWeaveStructureFromJSON(lastModifiedJSON.manageWeaveStructure),
      CardItem.weaveProductFromJSON(lastModifiedJSON.weaveProduct),
      CardItem.groupedWeaveStructureFromJSON(lastModifiedJSON.groupedWeaveStructure),
      CardItem.tuftProductFromJSON(lastModifiedJSON.tuftProduct)
    );
  }
}
